export class SmtpConfig {
    id: number|undefined;
    active:boolean;
    host:string;
    port:string;
    starttls:string;
    username:string;
    password:string;
  }